<template>
	<div class="page yarn-creation">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>				
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 100"><path d="M44.4 10h-22a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-20-4h18V4h-18zm27 94h-36a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-34-4h32v-2h-32z"/><path d="M57.9 94H9.1a9 9 0 0 1-9-9.85l6.45-67.3A12 12 0 0 1 18.5 6H50a12 12 0 0 1 12 11.15l4.8 67.2a9 9 0 0 1-9 9.64zM18.5 10a8 8 0 0 0-8 7.24l-6.37 67.3a5 5 0 0 0 5 5.47H57.9a5 5 0 0 0 5-5.36l-4.8-67.2a8 8 0 0 0-8-7.43z"/><path d="M60.2 24.85A17 17 0 0 1 45.41 8h4a13 13 0 0 0 11.32 12.89zM61.1 35A27 27 0 0 1 35.41 8h4a23 23 0 0 0 21.88 23zm.8 10A37.13 37.13 0 0 1 25.41 8h4a33.12 33.12 0 0 0 32.53 33zm.74 10h-.2a47.06 47.06 0 0 1-47-46.94h4a43.06 43.06 0 0 0 43 42.94h.2zm-.2 10a57 57 0 0 1-56-46.14l3.93-.76a53 53 0 0 0 52 42.9h.86l.13 4zm0 10A67.27 67.27 0 0 1 4.56 41.81l3.45-2A63.25 63.25 0 0 0 62.41 71H64l.07 4z"/><path d="M4.53 63.86L4 60a12.9 12.9 0 0 0 10.11-7.3l3.6 1.72a16.88 16.88 0 0 1-13.19 9.54zM3.4 74l-.14-4A22.92 22.92 0 0 0 22 59.12l3.4 2.1A26.91 26.91 0 0 1 3.39 74zM2.4 84v-4a32.84 32.84 0 0 0 28-15.55l3.4 2.12A36.82 36.82 0 0 1 2.41 84zm5.05 9.73l-.42-4a43.14 43.14 0 0 0 32.61-21.22l3.46 2A47.15 47.15 0 0 1 7.46 93.73zm27.72-.1l-2.3-3.27A53.26 53.26 0 0 0 49.6 71.16L53.16 73a57.27 57.27 0 0 1-17.98 20.64zm26.55-25.06v-.01h4l-4 .01zm-11 24.8l-2.88-2.77a62.57 62.57 0 0 0 12.31-18.43l3.67 1.6a66.55 66.55 0 0 1-13.1 19.6z"/></svg>
					<span class="navigation-title">{{$t('yarn-creation')}}</span>
					<div class="navigation-right">
						<router-link :to="{name: 'yarns'}"><svg class="navigation-icon link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 3H5C3.88 3 3 3.9 3 5V19a1.99 1.99 0 0 0 1.99 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"/></svg></router-link>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top">
				<div id="tabs">
						<div class="tabs-inner">
						<span
							v-for="tb in tabs"
							:key="tb.name"
							:class="['tab', {active: tab.name === tb.name}, {enabled: tb.enabled}]"
							@click="tab = tb">
							<span class="number">{{tb.number}}</span>
							<span class="title">{{tb.description}}</span>
						</span>
					</div>
				</div>
				<!-- <router-view :tab.sync = "tab"/> -->
				<transition name="slide-up" mode="out-in" appear>
					<component :is="tab.name" :data.sync="data" :result.sync="result"></component>
				</transition>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import Tab1 from '@/views/YarnCreation/Tab1.vue'
import Tab2 from '@/views/YarnCreation/Tab2.vue'
import Tab3 from '@/views/YarnCreation/Tab3.vue'

export default {
	props: {
		initialData: {
			type: Object,
		},
	},
	data() {
		let tabs = [
			{
				number: 1,
				name: 'tab-1',
				description: this.$t('semifinished-yarn-count'),
				enabled: true
			},
			{
				number: 2,
				name: 'tab-2',
				description: this.$t('production-parameters'),
				enabled: false
			},
			{
				number: 3,
				name: 'tab-3',
				description: this.$t('composition-and-final-yarn-count'),
				enabled: false
			}
		];

		let yarnType = this.$settings.data.defaultYarnType;

		return {
			tabs: tabs,
			tab: tabs[0],
			data: {
				workingPositions: 1,
				yarnName: '',
				yarnType: yarnType,
				needlesNumber: '',
				feedingLabel: this.getFeedingLabel(yarnType),
				minCores: 1,
				maxCores: 2,
				cores: [
					{
						yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
					}
				],
				coresA: [
					{
						yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
					}
				],
				coresB: [
					{
						yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
					}
				],
				minCoverings: 1,
				maxCoverings: 2,
				coverings: [
					{
						yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
					}
				],
				minEffects: 1,
				maxEffects: 3,
				effectType: 'roving',
				effects: [
					{
						weight: '',
						yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
					}
				],
				minSteps: 1,
				maxSteps: 10,
				steps: [
					{
						productionSpeed: '',
						number: 1,
						visible: true,
						length: 100,
						feeding: '',
						drafts: []
					}
				]
			},
			result: {
				yarnCount: 0,
				units: [...this.$yarnCountUtils.units]
			}
		};
	},
	components: {
		Tab1,
		Tab2,
		Tab3
	},
	watch: {
		'data': {
			handler() {
				this.calc();
			},
			deep: true
		},
		'data.yarnType': {
			handler() {
				switch (this.data.yarnType) {
					case 'fancy-yarn':
						this.data.workingPositions = 1;
						break;
					case 'ribbon-yarn':
						break;
					case 'soft-knit-yarn':
						break;
				}
				this.data.feedingLabel = this.getFeedingLabel(this.data.yarnType);
			}
		},
		'data.effectType': {
			handler() {
				this.updateDrafts();
			}
		},
		'data.effects': {
			handler() {
				this.updateDrafts();
			},
			deep: true
		}
	},
	methods: {
		enableTab(number) {
			var tb = this.tabs.find(tab => tab.number == number);
			if (tb) {
				tb.enabled = true;
				this.tab = tb;
			}
		},
		getFeedingLabel(yarnType) {
			var rst = '';
			switch (yarnType) {
				case 'fancy-yarn':
					rst = this.$t('feeding-?');
					break;
				case 'ribbon-yarn':
					rst = this.$t('feeding-speed-?');
					break;
				case 'soft-knit-yarn':
					rst = this.$t('feeding-speed-?');
					break;
			}
			return rst;
		},
		updateDrafts() {
			this.data.steps.forEach((step) => {
				if (this.data.effectType === 'yarn') {
					step.drafts = [];
				} else {
					while (step.drafts.length != this.data.effects.length) {
						if (step.drafts.length < this.data.effects.length) {
							step.drafts.push('');
						} else {
							step.drafts.pop();
						}
					}
				}
			});
		},
		calc() {
			var self = this;

			var needlesNumber = this.$utils.sanitize(this.data.needlesNumber);

			var weightDividend = 0;

			switch (self.data.yarnType) {
				case 'fancy-yarn': {
					weightDividend = 1;
					self.data.steps.forEach((step) => {
						step.productionSpeed = 1;
					});
					break;
				}
				case 'ribbon-yarn': {
					weightDividend = needlesNumber * 2.52;
					let feeding = weightDividend;
					break;
				}
				case 'soft-knit-yarn': {
					weightDividend = needlesNumber * 2.52;
					break;
				}
			}

			switch (self.data.workingPositions) {
				case 2: {
					self.data.coresA.forEach((core) => {
						var value = this.$utils.sanitize(core.yarnCount.value);
						var nm = self.$yarnCountUtils.convert(value, core.yarnCount.code, 'nm');
						var weight = (weightDividend / nm)/2;
						weight = this.$utils.sanitize(weight);
						core.result = {};
						core.result.weight = weight;
						//this.$set(core, 'result', {});
						//this.$set(core.result, 'weight', weight);
					});
					self.data.coresB.forEach((core) => {
						var value = this.$utils.sanitize(core.yarnCount.value);
						var nm = self.$yarnCountUtils.convert(value, core.yarnCount.code, 'nm');
						var weight = (weightDividend / nm)/2;
						weight = this.$utils.sanitize(weight);
						core.result = {};
						core.result.weight = weight;
						//this.$set(core, 'result', {});
						//this.$set(core.result, 'weight', weight);
					});
					break;
				}
				case 1: {
					self.data.cores.forEach((core) => {
						var value = this.$utils.sanitize(core.yarnCount.value);
						var nm = self.$yarnCountUtils.convert(value, core.yarnCount.code, 'nm');
						var weight = weightDividend / nm;
						weight = this.$utils.sanitize(weight);
						core.result = {};
						core.result.weight = weight;
						//this.$set(core, 'result', {});
						//this.$set(core.result, 'weight', weight);
					});
					break;
				}
			}

			self.data.coverings.forEach((covering) => {
				var value = this.$utils.sanitize(covering.yarnCount.value);
				var nm = self.$yarnCountUtils.convert(value, covering.yarnCount.code, 'nm');
				var weight = weightDividend / nm;
				weight = this.$utils.sanitize(weight);
				//this.$set(covering, 'result', {});
				//this.$set(covering.result, 'weight', weight);
				covering.result = {};
				covering.result.weight = weight;
			});

			var totalStepsLength = self.data.steps.reduce((acc, val) => acc + Number(this.$utils.sanitize(val.length)), 0);

			self.data.effects.forEach((effect, index) => {
				var totalWeight = 0;
				self.data.steps.forEach((step) => {

					var feeding = this.$utils.sanitize(step.feeding);
					var productionSpeed = this.$utils.sanitize(step.productionSpeed) || 1;

					var calcWeight = 0;
					switch(self.data.effectType) {
						case 'roving':
							var weight = this.$utils.sanitize(effect.weight);
							var draft = this.$utils.sanitize(step.drafts[index]);
							calcWeight = weight / draft * (feeding/productionSpeed);
							break;
						case 'yarn':
							var yarnCount = self.$yarnCountUtils.convert(effect.yarnCount.value, effect.yarnCount.code, 'nm');
							calcWeight = 1 / yarnCount * (feeding/productionSpeed);
							break;
					}
					calcWeight = this.$utils.sanitize(calcWeight);
					var stepLength = this.$utils.sanitize(step.length);

					var weightMt = calcWeight * stepLength / totalStepsLength;
					totalWeight += weightMt;
				});
				//this.$set(effect, 'result', {});
				//this.$set(effect.result, 'weight', totalWeight);
				effect.result = {};
				effect.result.weight = totalWeight;
			});

			var concat;
			switch (self.data.workingPositions){
				case 2: {
					concat = self.data.coresA.concat(self.data.coresB).concat(self.data.coverings).concat(self.data.effects);
					break;
				}
				case 1: {
					concat = self.data.cores.concat(self.data.coverings).concat(self.data.effects);
					break;
				}
			}
			var totalWeight = 0;

			totalWeight = concat.reduce((a, b) => a + b.result.weight, 0);

			switch (self.data.workingPositions){
				case 2: {
					self.data.coresA.forEach((core) => {
						var percentage = core.result.weight / totalWeight;
						percentage = this.$utils.sanitize(percentage);
						//this.$set(core.result, 'percentage', percentage);
						core.result.percentage = percentage;
					});
					self.data.coresB.forEach((core) => {
						var percentage = core.result.weight / totalWeight;
						percentage = this.$utils.sanitize(percentage);
						//this.$set(core.result, 'percentage', percentage);
						core.result.percentage = percentage;
					});
					break;
				}
				case 1: {
					self.data.cores.forEach((core) => {
						var percentage = core.result.weight / totalWeight;
						percentage = this.$utils.sanitize(percentage);
						//this.$set(core.result, 'percentage', percentage);
						core.result.percentage = percentage;
					});
					break;
				}
			}

			self.data.coverings.forEach((covering) => {
				var percentage = covering.result.weight / totalWeight;
				percentage = this.$utils.sanitize(percentage);
				//this.$set(covering.result, 'percentage', percentage);
				covering.result.percentage = percentage;
			});

			self.data.effects.forEach((effect) => {
				var percentage = effect.result.weight / totalWeight;
				percentage = this.$utils.sanitize(percentage);
				//this.$set(effect.result, 'percentage', percentage);
				effect.result.percentage = percentage;
			});

			self.result.yarnCount = 1 / totalWeight;
			self.result.yarnCount = this.$utils.sanitize(self.result.yarnCount);
			this.convert();
		},
		convert() {
			var self = this;
			self.result.units.forEach(function(unit, index) {
				unit.value = self.$yarnCountUtils.convert(self.result.yarnCount, 'nm', unit.code);
				self.$set(self.result.units, index, unit);
			});
		}
	},
	created() {
		if (this.initialData != null) {
			this.$set(this, 'data', {
				...this.initialData,
				effects: [...this.initialData.effects].map(effect => {
					const temp = {...effect, yarnCount: {...effect.yarnCount}};
					delete temp.result;
					return temp;
				}),
				cores: [...this.initialData.cores].map(core => {
					const temp = {...core, yarnCount: {...core.yarnCount}};
					delete temp.result;
					return temp;
				}),
				/* coresA: [...this.initialData.coresA].map(core => {
					const temp = {...core, yarnCount: {...core.yarnCount}};
					delete temp.result;
					return temp;
				}) || [],
				coresB: [...this.initialData.coresB].map(core => {
					const temp = {...core, yarnCount: {...core.yarnCount}};
					delete temp.result;
					return temp;
				}) || [], */
				coverings: [...this.initialData.coverings].map(covering => {
					const temp = {...covering, yarnCount: {...covering.yarnCount}};
					delete temp.result;
					return temp;
				}),
				steps: [...this.initialData.steps].map(step => {
					return {...step, drafts: [...step.drafts], productionSpeed: step.productionSpeed || 1};
				})

			});

			if(this.initialData.hasOwnProperty('workingPositions')){
				this.$set(this.data, 'workingPositions', this.initialData.workingPositions);
			} else {
				this.$set(this.data, 'workingPositions', 1);
			}
			if(this.initialData.hasOwnProperty('coresA')) {
				const coresA = [...this.initialData.coresA].map(core => {
					const temp = {...core, yarnCount: {...core.yarnCount}};
					delete temp.result;
					return temp;
				})
				this.$set(this.data, 'coresA', coresA);
			} else {
				this.$set(this.data, 'coresA', []);
			}
			if(this.initialData.hasOwnProperty('coresB')) {
				const coresB = [...this.initialData.coresB].map(core => {
					const temp = {...core, yarnCount: {...core.yarnCount}};
					delete temp.result;
					return temp;
				})
				this.$set(this.data, 'coresB', coresB);
			} else {
				this.$set(this.data, 'coresB', []);
			}

			this.calc();
			this.enableTab(2);
			this.enableTab(3);
			this.enableTab(1);
		}
		this.updateDrafts();
	}
}
</script>

<style>
.yarn-creation .add-more {
	display: block;
	width: 1.6rem;
	height: 1.6rem;
}

.yarn-creation .add-more svg {
	display: block;
	width: 100%;
	height: 100%;
}

.yarn-creation .add-more path {
	fill: var(--primary_color);
}

.yarn-creation .add-more.remove path {
	fill: var(--primary_text_color);
}

.yarn-creation .field .add-more {
	align-self: flex-end;
	margin-top: 1.6rem;
}

.yarn-creation .field .info {
	display: block;
	width: 1.6rem;
	height: 1.6rem;
}

.yarn-creation .field .info svg {
	display: block;
	width: 100%;
	height: 100%;
}

.yarn-creation .field .info svg path {
	fill: var(--primary_text_color);
}
</style>